/* tslint:disable */
/* eslint-disable */
/**
 * TOM BILLING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommodityDto } from '../model';
// @ts-ignore
import type { CommodityInfoDto } from '../model';
// @ts-ignore
import type { CreateCommoditiesCommand } from '../model';
// @ts-ignore
import type { CreateCommodityCommand } from '../model';
// @ts-ignore
import type { SuggestedCommodityCodeDto } from '../model';
// @ts-ignore
import type { UpdateCommodityCommand } from '../model';
/**
 * CommoditiesApi - axios parameter creator
 */
export const CommoditiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            const localVarPath = `/billingService/api/Commodities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCommodityCommand} [createCommodityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createCommodityCommand?: CreateCommodityCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Commodities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCommodityCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCommoditiesCommand} [createCommoditiesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommodities: async (createCommoditiesCommand?: CreateCommoditiesCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Commodities/CreateCommodities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCommoditiesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivate: async (id?: number, isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Commodities/Deactivate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (query?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Commodities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                for (const [key, value] of Object.entries(query)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [catalogueId] 
         * @param {number} [parentCommodityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedCode: async (catalogueId?: number, parentCommodityId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Commodities/GetSuggestedCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (catalogueId !== undefined) {
                localVarQueryParameter['CatalogueId'] = catalogueId;
            }

            if (parentCommodityId !== undefined) {
                localVarQueryParameter['ParentCommodityId'] = parentCommodityId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get_1: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get_1', 'id', id)
            const localVarPath = `/billingService/api/Commodities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCommodityCommand} [updateCommodityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (updateCommodityCommand?: UpdateCommodityCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/Commodities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommodityCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommoditiesApi - functional programming interface
 */
export const CommoditiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommoditiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommoditiesApi._delete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateCommodityCommand} [createCommodityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createCommodityCommand?: CreateCommodityCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createCommodityCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommoditiesApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateCommoditiesCommand} [createCommoditiesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCommodities(createCommoditiesCommand?: CreateCommoditiesCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCommodities(createCommoditiesCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommoditiesApi.createCommodities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivate(id?: number, isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivate(id, isActive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommoditiesApi.deactivate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {object} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(query?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommodityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommoditiesApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [catalogueId] 
         * @param {number} [parentCommodityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuggestedCode(catalogueId?: number, parentCommodityId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuggestedCommodityCodeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuggestedCode(catalogueId, parentCommodityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommoditiesApi.getSuggestedCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get_1(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommodityInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get_1(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommoditiesApi.get_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateCommodityCommand} [updateCommodityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(updateCommodityCommand?: UpdateCommodityCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(updateCommodityCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommoditiesApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommoditiesApi - factory interface
 */
export const CommoditiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommoditiesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCommodityCommand} [createCommodityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createCommodityCommand?: CreateCommodityCommand, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.create(createCommodityCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCommoditiesCommand} [createCommoditiesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommodities(createCommoditiesCommand?: CreateCommoditiesCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createCommodities(createCommoditiesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivate(id?: number, isActive?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deactivate(id, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {object} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(query?: object, options?: RawAxiosRequestConfig): AxiosPromise<Array<CommodityDto>> {
            return localVarFp.get(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [catalogueId] 
         * @param {number} [parentCommodityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedCode(catalogueId?: number, parentCommodityId?: number, options?: RawAxiosRequestConfig): AxiosPromise<SuggestedCommodityCodeDto> {
            return localVarFp.getSuggestedCode(catalogueId, parentCommodityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get_1(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CommodityInfoDto> {
            return localVarFp.get_1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCommodityCommand} [updateCommodityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(updateCommodityCommand?: UpdateCommodityCommand, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.update(updateCommodityCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommoditiesApi - object-oriented interface
 */
export class CommoditiesApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public _delete(id: number, options?: RawAxiosRequestConfig) {
        return CommoditiesApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCommodityCommand} [createCommodityCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public create(createCommodityCommand?: CreateCommodityCommand, options?: RawAxiosRequestConfig) {
        return CommoditiesApiFp(this.configuration).create(createCommodityCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCommoditiesCommand} [createCommoditiesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCommodities(createCommoditiesCommand?: CreateCommoditiesCommand, options?: RawAxiosRequestConfig) {
        return CommoditiesApiFp(this.configuration).createCommodities(createCommoditiesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {boolean} [isActive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deactivate(id?: number, isActive?: boolean, options?: RawAxiosRequestConfig) {
        return CommoditiesApiFp(this.configuration).deactivate(id, isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {object} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public get(query?: object, options?: RawAxiosRequestConfig) {
        return CommoditiesApiFp(this.configuration).get(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [catalogueId] 
     * @param {number} [parentCommodityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSuggestedCode(catalogueId?: number, parentCommodityId?: number, options?: RawAxiosRequestConfig) {
        return CommoditiesApiFp(this.configuration).getSuggestedCode(catalogueId, parentCommodityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public get_1(id: number, options?: RawAxiosRequestConfig) {
        return CommoditiesApiFp(this.configuration).get_1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCommodityCommand} [updateCommodityCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public update(updateCommodityCommand?: UpdateCommodityCommand, options?: RawAxiosRequestConfig) {
        return CommoditiesApiFp(this.configuration).update(updateCommodityCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

